import React, { Fragment, useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Slide from "@material-ui/core/Slide";
import TransmittalDetailsForm from "../DocumentWorkflow/Transmittal/TransmittalDetailsForm";

import LockScreenLoading from "../LockScreenLoading/LockScreenLoading";
import FullScreenDialog from "./FullScreenDialog";
// Material-UI Element
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

// Custom Style
import { oceanBlueColor } from "../../styles/jss/cmsMainStyle";
import { confirmDialogStyle } from "../../styles/jss/components/dialog/confirmDialogStyle";

// Fetch Data
import {
  fileUpload,
  fileDownload,
  addFileProperty,
} from "../../dataSource/fileManager";
import { sub } from "date-fns";

import { saveRFI, generatePdf } from "../../dataSource/rfi";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => confirmDialogStyle(theme));

const TransmittalConfirmDialog = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    open,
    dialogTitle,
    transRFITemplate,
    setTransRFITemplate,
    attentionContent,
    setOpenDialog,
    setList,
    filterList,
    submissionValue,
    setSubmissionValue,
    cancelAction,
    fromRFI,
    confirmDialogHandleClose,
    transmittal,
    rfi_seq,
    buildAlert,
  } = props;
  const [fileUploadingProperty, setFileUploadingProperty] = useState([]);
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [openTransmittalDialog, setOpenTransmittalDialog] = useState(false);
  const [rfiToXmtlData, setRfiToXmtlData] = useState({});
  const [progressTitle, setProgressTitle] = useState("");
  // Handle Input
  const handleInputChange = (name) => (event) => {
    setTransRFITemplate({ ...transRFITemplate, [name]: event.target.value });
  };

  // Main Action
  const fileUploadAction = (fileType, acceptedFilesPool) => {
    let UploadingSource = buildFileUploadingProperty(acceptedFilesPool);
    acceptedFilesPool.map((file) => {
      fileUpload(file).then((res) => {
        console.log(
          "*****************************************************************************"
        );
        console.log("Temporary upload File Successful");
        console.log(res);
        console.log(
          "*****************************************************************************"
        );
        UploadingSource = removeFileUploadingProperty(UploadingSource, file);
        // buildFileRecordFromHarddisk(fileType, res.data[0])
        buildFileRecord(fileType, res.data[0]);
      });
    });
  };
  const buildFileUploadingProperty = (fileUploadRecord) => {
    const res = [...fileUploadingProperty, ...fileUploadRecord];

    setFileUploadingProperty(res);
    dispatch({
      type: "ADD_FILE_UPLOADING_PROPERTY",
      data: res,
    });

    return res;
  };
  const removeFileUploadingProperty = (sourceRecords, key) => {
    if (sourceRecords) {
      const res = sourceRecords.filter((sourceRecord) => sourceRecord !== key);

      setFileUploadingProperty(res);
      dispatch({
        type: "ADD_FILE_UPLOADING_PROPERTY",
        data: res,
      });

      return res;
    }
  };

  const buildFileRecord = (fileType, fileUploadRecord) => {
    const val = { ...transRFITemplate };
    fileUploadRecord.modifydate = "";
    val.messages.files.push(fileUploadRecord);
    setTransRFITemplate({ ...transRFITemplate, ...val });
    dispatch({
      type: "ADD_TRANSMITTAL_SOFTCOPY_SUBMISSION_VALUE",
      data: { ...transRFITemplate, val },
    });
    for (const atth of val.messages.files) {
      let data = { ...submissionValue };
      if (
        data.documents.map((obj) => obj.file_seq).indexOf(atth.file_seq) === -1
      ) {
        let fileObject = {
          id: uuidv4(),
          material: `${transRFITemplate.ref_no}.pdf`,
          ref_no: transRFITemplate.ref_no,
          atthDate: transRFITemplate.atthDate,
          description: transRFITemplate.description,
          type: "rfi",
          file_seq: atth.file_seq,
          messages: val.messages,
          files: atth,
        };
        setRfiToXmtlData({ ...setRfiToXmtlData, ...fileObject });
        data.documents.push(fileObject);
        setSubmissionValue({ ...submissionValue, ...data });
        dispatch({
          type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
          data: { ...submissionValue, data },
        });
      }
    }
  };

  const confirmAction = () => {
    let rfiAttachment = {};
    rfiAttachment.rfi_seq = rfi_seq;
    rfiAttachment.ref_no = transRFITemplate.ref_no;
    rfiAttachment.transmittal = transmittal;
    setLockScreenLoadingOpen(true);
    confirmDialogHandleClose();
    saveRFI(rfiAttachment).then((res) => {
      buildFileRecord("transmittal", res.data.data[0]);
      setLockScreenLoadingOpen(false);
      if (!fromRFI) {
        setOpenDialog(false);
        setList(filterList);
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "success",
          title: "Success Alert",
          content: "The RFI  have been added to Transmittal",
        });
      } else {
        alert("The RFI  have been added to Transmittal");
        setOpenTransmittalDialog(true);
      }
    });
  };

  const newTransmittalDialogTitle = `New Transmittal`;

  return (
    <Fragment>
      <FullScreenDialog
        open={openTransmittalDialog}
        dialogTitle={newTransmittalDialogTitle}
        formContent={
          <TransmittalDetailsForm
            rfiToXmtlData={rfiToXmtlData}
            transFromRFI={true}
            openDialog={openTransmittalDialog}
            setOpenDialog={setOpenTransmittalDialog}
            buildAlert={buildAlert}
            isInternal={true}
            isNew={true}
          />
        }
        button={[]}
        handleClose={() => {
          setOpenTransmittalDialog(false);
        }}
      />
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth={true}
        // onClose={handleClose}
        aria-labelledby="confirmDialogTitle"
        aria-describedby="confirmDialogDescription"
        PaperProps={{
          style: {
            background:
              "linear-gradient(0deg, " +
              oceanBlueColor[4] +
              ", " +
              oceanBlueColor[0] +
              ")",
          },
        }}
      >
        <DialogTitle id="confilmDialogTitle">{dialogTitle}</DialogTitle>

        <DialogContent>
          <Grid item xs={12}>
            <Grid>
              <TextField
                className={classes.textField}
                fullWidth={true}
                id={"material"}
                name={"material"}
                label={"Submission Material Type"}
                type="text"
                size="small"
                variant="outlined"
                value={transRFITemplate.material || ""}
                InputProps={{
                  readOnly: true,
                  maxLength: 255,
                }}
              />
            </Grid>
            <br />
            <Grid>
              <TextField
                className={classes.textField}
                fullWidth={true}
                id={"material"}
                name={"material"}
                label={"Ref No."}
                type="text"
                size="small"
                variant="outlined"
                value={transRFITemplate.ref_no || ""}
                InputProps={{
                  readOnly: true,
                  maxLength: 255,
                }}
              />
            </Grid>
          </Grid>
          <br />
          <Grid item xs={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                className={classes.textField}
                id={"date"}
                name={"atthDate"}
                label={"RFI Create Date"}
                required={true}
                format="dd/MM/yyyy"
                placeholder="DD/MM/YYYY"
                size="small"
                fullWidth={true}
                inputVariant="outlined"
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                value={
                  transRFITemplate.atthDate != null
                    ? transRFITemplate.atthDate
                    : null
                }
                InputProps={{
                  readOnly: true,
                  maxLength: 255,
                }}
                readOnly={true}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <br />
          <Grid item xs={12}>
            <TextField
              className={classes.textField}
              fullWidth={true}
              id={"description"}
              name={"description"}
              label={"Description"}
              type="text"
              //	required={element.mandatory}
              size="small"
              variant="outlined"
              value={transRFITemplate.description || ""}
              onChange={handleInputChange("description")}
            />
          </Grid>

          <DialogContentText
            id="confirmDialogContent"
            className={classes.attentionContent}
          >
            {attentionContent ? "Attention: " + attentionContent : ""}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={cancelAction}
            className={classes.actionButton}
            autoFocus
          >
            Cancel
          </Button>

          <Button onClick={confirmAction} className={classes.actionButton}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default TransmittalConfirmDialog;
